import GraphicObject, { GraphicsObjectOptions } from "./GraphicObject";

export type TickingObjectOptions = GraphicsObjectOptions

export default class TickingObject<T, C> extends GraphicObject<T, C> {
	tick(delta: number) { }
}
